<script>
    import { onMount } from 'svelte';

    export let store = 'en';
    // export let content;
    let content = 'not loaded';

    ;
    onMount(() => {
        content = getStack('typo3_service_box');
    });
</script>

<div data-store={store}>
    {#if content}<span>{@html content}</span>{/if}
</div>


<style>
    div {
        flex-grow: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        background-color: #fef8e9;
        -webkit-transition: 1s ease-in-out;
    transition: 1s ease-in-out;
    }
    div:hover{
        -webkit-box-shadow: 0 0 10px 2px rgba(119,119,119,.15);
    box-shadow: 0 0 10px 2px rgba(119,119,119,.15);
    }
    span {
        display: block;
        text-align: center;
    }
</style>